import { render, staticRenderFns } from "./DealRating.vue?vue&type=template&id=117ad972&scoped=true&"
import script from "./DealRating.vue?vue&type=script&lang=js&"
export * from "./DealRating.vue?vue&type=script&lang=js&"
import style0 from "./DealRating.vue?vue&type=style&index=0&id=117ad972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ad972",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TacoRating: require('/app/appsumo/nuxt/components/TacoRating.vue').default})
